import {configureStore} from "@reduxjs/toolkit";
import {createWrapper} from "next-redux-wrapper";
import {usuarioSlice} from "@/store/slices/userSlice";
import {appSlice} from "@/store/slices/appSlice";
import {paymentSlice} from "@/store/slices/paymentSlice";
import {offerSlice} from "@/store/slices/offerSlice";
import {leadSlice} from "@/store/slices/leadSlice";

const makeStore = () => configureStore({
    reducer: {
        [usuarioSlice.name]: usuarioSlice.reducer,
        [paymentSlice.name]: paymentSlice.reducer,
        [appSlice.name]: appSlice.reducer,
        [offerSlice.name]: offerSlice.reducer,
        [leadSlice.name]: leadSlice.reducer,
    },
    devTools: true,
})

export const wrapper = createWrapper(makeStore)